import React from 'react';

import styled from 'styled-components';

import Picture from 'components/picture';

const Quote = styled.h2``;

const BlockQuote = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 90%;
  max-width: 730px;
  flex-grow: 1;
  padding: 2rem 0rem;
  & > ${Quote} {
    padding: 0rem 0rem 1rem;
    text-align: center;
  }
`;

const Attribution = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr;
  margin: 0 auto;
`;

const AttributionText = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  width: 100%;
  align-self: center;
  padding-left: 1rem;
  & > div {
    height: 22px;
    line-height: 22px;
  }
`;

const AttributionPhoto = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding-bottom: 100%;
  border-radius: 9999rem;
  overflow: hidden;
`;

const Image = styled(Picture)`
  display: block;
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

class QuoteWidget extends React.Component {
  render() {
    return (
      <BlockQuote>
        <Quote>“{this.props.quoteText?.locale}”</Quote>
        <Attribution>
          <AttributionPhoto>
            <Image image={this.props.attributionImage} />
          </AttributionPhoto>
          <AttributionText>
            <div className="attributionName">{this.props.attributionName}</div>
            <div className="attributionTitle">{this.props.attributionTitle?.locale}</div>
          </AttributionText>
        </Attribution>
      </BlockQuote>
    );
  }
}

export default QuoteWidget;
